module.exports = __webpack_public_path__ + "static/media/truck_2t_mini.60448a02.svg";